import * as React from 'react';

import { useCreateModel } from 'src/containers/ProjectResourceSuggestionsDialog/hooks/useCreateModel';
import { useGenerateMockData } from 'src/containers/ProjectResourceSuggestionsDialog/hooks/useGenerateMockData';
import { useGenerateDataModel } from 'src/utils/voicebox/hooks/useGenerateDataModel';

/**
 *  Generate model and data (no resources, no classes)
 * - Generate data model
 * - Add model to canvas
 * - Generate synthetic CSV data (via useGenerateMockDataForModel)
 * - Import CSV files (via useGenerateMockDataForModel)
 * - Transform and apply mappings (via useGenerateMockDataForModel)
 */
export const useGenerateModelAndMockData = () => {
  const generateDataModel = useGenerateDataModel();
  const createModel = useCreateModel();
  const generateMockData = useGenerateMockData();

  return React.useCallback(async (): Promise<{
    success: boolean;
  }> => {
    const modelJsonLd = await generateDataModel();
    if (!modelJsonLd) {
      return { success: false };
    }

    const createdClassIris = await createModel(modelJsonLd);

    return generateMockData(createdClassIris);
  }, [generateDataModel, createModel, generateMockData]);
};
